import { Component, Input } from '@angular/core';

@Component({
  selector: 'split-doughnut-v2',
  templateUrl: './split-doughnut-v2.component.html',
  styleUrls: ['./split-doughnut-v2.component.scss']
})
export class SplitDoughnutV2Component {
  dataSet: any = {};
  _data: any = [];

  get data() {
    return this._data;
  }
  @Input() options: any;
  @Input() set data(data: any) {
    this._data = data;
    this.dataSet = {
      labels: this.labels,
      datasets: [
          {
              data: data,
              backgroundColor: this.colors,
              hoverBackgroundColor: this.colors
          }
      ]
    }
  }
  @Input() colors: any = [];
  @Input() labels: any = [];
  @Input() height: any = '190px';
 
  ngOnInit() {
    this.createOptions();

  }
  createOptions() {
    this.options = {
      responsive: false,
      maintainAspectRatio: false,
      cutout: '80%',
      plugins: {
        legend: {
          display: false
        }
      }
    };
  }
}
   

